// ─── Spacing Scale ────────────────────────────────────────────
export const spacing = {
  xs:  '0.5rem',
  sm:  '0.75rem',
  md:  '1rem',
  lg:  '1.5rem',
  xl:  '2rem',
  '2xl': '3rem',
  '3xl': '4rem',
  '4xl': '6rem',
};

// ─── Section Spacing ──────────────────────────────────────────
export const sectionSpacing = {
  mobileY:    '4rem',
  desktopY:   '6rem',
  innerGapSm: '1rem',
  innerGapMd: '1.5rem',
  innerGapLg: '2rem',
};

// ─── Radius Tokens ────────────────────────────────────────────
export const radius = {
  none:    '0',
  soft:    '0.75rem',
  rounded: '1.25rem',
  pill:    '9999px',
};

// ─── Shadow Tokens ────────────────────────────────────────────
export const shadows = {
  none:     'none',
  soft:     '0 8px 30px rgba(0,0,0,0.08)',
  card:     '0 12px 40px rgba(0,0,0,0.10)',
  elevated: '0 20px 60px rgba(0,0,0,0.14)',
};

// ─── Overlay Tokens ───────────────────────────────────────────
export const overlays = {
  none:        'none',
  'dark-soft':   'linear-gradient(rgba(0,0,0,0.28), rgba(0,0,0,0.28))',
  'dark-strong': 'linear-gradient(rgba(0,0,0,0.46), rgba(0,0,0,0.46))',
  'warm-soft':   'linear-gradient(rgba(60,40,20,0.18), rgba(60,40,20,0.18))',
  'glass-light': 'rgba(255,255,255,0.16)',
};

// ─── Container Width Tokens ───────────────────────────────────
export const containers = {
  sm: '640px',
  md: '768px',
  lg: '1024px',
  xl: '1200px',
};

// ─── Surface Tokens ───────────────────────────────────────────
export const surfaces = {
  plain: {
    shadow: 'none',
    border: true,
    backdrop: false,
  },
  cardSoft: {
    shadow: 'soft',
    border: true,
    backdrop: false,
  },
  glass: {
    shadow: 'soft',
    border: true,
    backdrop: true,
    backdropBlur: '12px',
  },
};

// ─── Button Tokens ────────────────────────────────────────────
export const buttons = {
  primary: {
    height: '3rem',
    paddingX: '1.25rem',
    radius: 'pill',
    fontSize: '0.95rem',
    fontWeight: 500,
  },
  secondary: {
    height: '3rem',
    paddingX: '1.25rem',
    radius: 'pill',
    fontSize: '0.95rem',
    fontWeight: 500,
  },
};

// ─── Motion Tokens ────────────────────────────────────────────
export const motion = {
  durationFast: 0.45,
  durationBase: 0.7,
  durationSlow: 0.9,
  staggerTight: 0.06,
  staggerBase: 0.1,
  easeLuxury: [0.22, 1, 0.36, 1],
};
